"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TwoFactorAttemptsExhausted = require("./TwoFactorAttemptsExhausted");
Object.keys(_TwoFactorAttemptsExhausted).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TwoFactorAttemptsExhausted[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TwoFactorAttemptsExhausted[key];
    }
  });
});